import { useCallback } from 'react';
import axios from 'axios';

import { useMutation, useQuery, useSuspenseQueries, useSuspenseQuery } from '@tanstack/react-query';

import { LOCAL_LANGUAGE } from '@/constants/storageKey';
import {
  CODE_API_URL,
  FOOTER_ADDRESS_URL,
  FOOTER_CONTACT_URL,
  FOOTER_MENU_URL,
  FOOTER_SNS_URL,
  PRIVACY_POLICY_URL,
  SEND_EMAIL_API_URL,
  TERMS_CONDITIONS_URL,
} from '@/constants/apiUrls';
import {
  ARENA_EVENT_CATEGORY_KEY,
  BUSINESS_CATEGORY_KEY,
  FOOTER_ADDRESS_KEY,
  FOOTER_CONTACT_KEY,
  FOOTER_MENU_KEY,
  FOOTER_SNS_KEY,
  MEETING_EVENT_CATEGORY_KEY,
  PRIVACY_POLICY_KEY,
  RETRACTABLE_OPTIONS_KEY,
  STAGE_TYPE_KEY,
  TERMS_CONDITIONS_KEY,
} from '@/constants/queryKey';

export function useGetBusinessCategory() {
  const language = localStorage.getItem(LOCAL_LANGUAGE);

  const getBusinessCategory = useCallback(async () => {
    const { status, data } = await axios.get(`${CODE_API_URL}/1?lang=${language}`);

    if (status === 200) {
      return data.data;
    }
  }, [language]);

  return useQuery({ queryKey: [BUSINESS_CATEGORY_KEY, language], queryFn: getBusinessCategory });
}

export function useGetArenaEventCategory() {
  const language = localStorage.getItem(LOCAL_LANGUAGE);

  const getArenaEventCategory = useCallback(async () => {
    const { status, data } = await axios.get(`${CODE_API_URL}/2?lang=${language}`);

    if (status === 200) {
      return data.data;
    }
  }, [language]);

  return useQuery({
    queryKey: [ARENA_EVENT_CATEGORY_KEY, language],
    queryFn: getArenaEventCategory,
  });
}

export function useGetMeetingEventCategory() {
  const language = localStorage.getItem(LOCAL_LANGUAGE);

  const getMeetingEventCategory = useCallback(async () => {
    const { status, data } = await axios.get(`${CODE_API_URL}/11?lang=${language}`);

    if (status === 200) {
      return data.data;
    }
  }, [language]);

  return useQuery({
    queryKey: [MEETING_EVENT_CATEGORY_KEY, language],
    queryFn: getMeetingEventCategory,
  });
}

export function useGetStageType() {
  const language = localStorage.getItem(LOCAL_LANGUAGE);

  const getStageType = useCallback(async () => {
    const { status, data } = await axios.get(`${CODE_API_URL}/3?lang=${language}`);

    if (status === 200) {
      return data.data;
    }
  }, [language]);

  return useQuery({
    queryKey: [STAGE_TYPE_KEY, language],
    queryFn: getStageType,
  });
}

export function useGetRetractableOptions() {
  const language = localStorage.getItem(LOCAL_LANGUAGE);

  const getRetractableOptions = useCallback(async () => {
    const { status, data } = await axios.get(`${CODE_API_URL}/10?lang=${language}`);

    if (status === 200) {
      return data.data;
    }
  }, [language]);

  return useQuery({
    queryKey: [RETRACTABLE_OPTIONS_KEY, language],
    queryFn: getRetractableOptions,
  });
}

// Footer.jsx
// export function useGetFooterInformation() {
//   const language = localStorage.getItem(LOCAL_LANGUAGE);

//   return useSuspenseQueries({
//     queries: [
//       {
//         queryKey: [FOOTER_ADDRESS_KEY],
//         queryFn: () => axios.get(`${FOOTER_ADDRESS_URL}&language=${language}`),
//         select: (data) => data.data[0],
//       },
//       {
//         queryKey: [FOOTER_MENU_KEY],
//         queryFn: () => axios.get(`${FOOTER_MENU_URL}&language=${language}`),
//         select: (data) => data.data.data,
//       },
//       {
//         queryKey: [FOOTER_CONTACT_KEY],
//         queryFn: () => axios.get(`${FOOTER_CONTACT_URL}&language=${language}`),
//         select: (data) => data.data[0],
//       },
//       {
//         queryKey: [FOOTER_SNS_KEY],
//         queryFn: () => axios.get(`${FOOTER_SNS_URL}&language=${language}`),
//         select: (data) => data.data[0],
//       },
//     ],
//   });
// }

// export function useGetPrivacyPolicy() {
//   const language = localStorage.getItem(LOCAL_LANGUAGE);

//   const getPrivacyPolicy = useCallback(async () => {
//     return await axios.get(`${PRIVACY_POLICY_URL}?language=${language}`);
//   }, [language]);

//   return useSuspenseQuery({
//     queryKey: [PRIVACY_POLICY_KEY, language, localStorage],
//     queryFn: getPrivacyPolicy,
//     select: (data) => data.data[0],
//   });
// }

// export function useGetTermsConditions() {
//   const language = localStorage.getItem(LOCAL_LANGUAGE);

//   const getTermsConditions = useCallback(async () => {
//     return await axios.get(`${TERMS_CONDITIONS_URL}?language=${language}`);
//   }, [language]);

//   return useSuspenseQuery({
//     queryKey: [TERMS_CONDITIONS_KEY, language, localStorage],
//     queryFn: getTermsConditions,
//     select: (data) => data.data[0],
//   });
// }

export function usePostEmailForm() {
  const postEmailForm = useCallback(async (data) => {
    return await axios.post(SEND_EMAIL_API_URL, data);
  }, []);

  const mutation = useMutation({
    mutationFn: postEmailForm,
    onSuccess: (data) => {
      if (data.data.code === 200) {
        return true;
      }
    },
    onError: (error) => {
      console.log(error);
      return false;
    },
  });

  return {
    mutate: mutation.mutate,
    isSuccess: mutation.isSuccess,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
